import { Component } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './app.logo.component.html',
  styleUrls: ['./app.logo.component.scss'],
})
export class AppLogoComponent {}
